export function parseTabularData(pastedData, numberOfColumns) {
  const tabData = pastedData
    .replace(/\r/g, '') // Remove carriage returns
    .split('\n') // Split into rows
    .map((line) => line.split('\t').slice(0, numberOfColumns)) // Split and trim columns
    .filter(
      (row) =>
        row.some((cell) => cell.trim() !== '') && // At least one non-empty cell
        row.slice(1).every((cell) => !isNaN(Number(cell))), // All columns except first must be numeric
    )
    .map((row) => {
      for (let i = 1; i < row.length; i++) {
        row[i] = Number(row[i]); // Convert numeric strings to actual numbers
      }
      return row;
    });

  // Remove rows with duplicate first-column values
  const seen = new Set();
  const uniqueTabData = tabData.filter((row) => {
    const key = row[0];
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });

  return uniqueTabData;
}
